import SubCategoriesList from './SubCategoriesList'
export default SubCategoriesList
